// extracted by mini-css-extract-plugin
export var cell = "_5p-4";
export var headerCell = "_5p-2";
export var rowHeader = "_5p-3";
export var table = "_5p-1";
export var tableContainer = "_5p-0";